import './center-gutter-tabs.css'

const tabs = [
    {label: 'Family Info', type: 'family'},
    {label: 'Students', type: 'students'},
    {label: 'Cancellations', type: 'cancellations'}
]

const CenterGutterTabs = ({tab, setTab, cancellations}) => {

    const tallyCancellations = (cancellations) => {
        let tally = 0
        cancellations.forEach(cancellation => {
            !cancellation.teacherCancelled && tally++
        })
        return tally
    }

    return (
        <div className='center-gutter-tabs__wrapper'>
            {tabs.map((listTab, index) =>
                <div 
                    key={index} 
                    className='center-gutter-tabs__tab' 
                    style={tab === listTab.type ? {borderBottom: '2px solid #6366F1', color: '#6366F1'} : {borderBottom: 'none', color: '#94A3B8'}}
                    onClick={() => setTab(listTab.type)}
                >
                    {listTab.label}
                    {listTab.type === 'cancellations' && cancellations && cancellations.length > 0 && <div className='center-gutter-tabs__cancellations-tally'>{tallyCancellations(cancellations)}</div>}
                </div>
            )}
        </div>
    )
}
export default CenterGutterTabs